import EventBus from '@/vue/EventBus';

const init = () => {
  const searchIcons = document.querySelectorAll('.js-search'); 
  if (searchIcons.length > 0) {
    searchIcons.forEach(searchIcon => {
      searchIcon.addEventListener('click', () => {
        EventBus.emit('open-search-modal');
      });
    });
  }
};

// Ensure init is called after DOM is fully loaded
document.addEventListener('DOMContentLoaded', init);

export { init };